import { AppNavigation } from '@layout/core/interfaces';
import { AppRoutes } from '@shared/enums';
import { environment } from '@environments/environment';
import { AppNavigationOptionsEnum } from '../enums/my-orders-navigation-options.enum';

export class AppNavigationCreator {
    static create(item: AppNavigation) {
        return {
            ...item,
        };
    }

    static createMyOrdersNavigation(): AppNavigation[] {
        return [
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_GENOTYPING_ORDERS,
                label: 'toolbar.myOrders.genotypingOrders',
                url: AppRoutes.ORDERS_LISTING,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_GENETIC_MONITORING,
                label: 'toolbar.myOrders.geneticMonitoringOrders',
                url: environment.geneticMonitoring + '/home',
                icon: '',
                internalRoute: false,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_MICROBIOME_ORDERS,
                label: 'toolbar.myOrders.microbiomeOrders',
                url: environment.microbiome + '/Home',
                icon: '',
                internalRoute: false,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_START_NEW_ORDER,
                label: 'toolbar.myOrders.startNewOrder',
                url: AppRoutes.ORDER_SETUP_STRAIN_SELECTION,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_CHECKMATE,
                label: 'toolbar.myOrders.checkmate',
                url: AppRoutes.CKM_LISTING,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_RESULTS_AVAILABILITY_SCHEDULE,
                label: 'toolbar.myOrders.resultsAvailabilitySchedule',
                url: AppRoutes.ORDERS_RESULTS_AVAILABILITY_SCHEDULE,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_WELLPLATE_STORAGE,
                label: 'toolbar.myOrders.wellplateStorage',
                url: AppRoutes.ORDERS_WELLPLATE_STORAGE,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_ORDERS_FAQ,
                label: 'toolbar.myOrders.orderFAQ',
                url: AppRoutes.ORDERS_FAQ,
                icon: '',
                internalRoute: true,
            }),
        ];
    }

    static createMySuppliesNavigation(): AppNavigation[] {
        return [
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_SUPPLIES_OVERVIEW,
                label: 'toolbar.mySupplies.overview',
                url: AppRoutes.SUPPLIES_OVERVIEW,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_SUPPLIES_REQUEST_SUPPLIES,
                label: 'toolbar.mySupplies.requestSupplies',
                url: AppRoutes.SUPPLIES_REQUEST,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_SUPPLIES_FAQ,
                label: 'toolbar.mySupplies.supplyFAQ',
                url: AppRoutes.SUPPLIES_FAQ,
                icon: '',
                internalRoute: true,
            }),
        ];
    }

    static createMyStrainsNavigation(): AppNavigation[] {
        return [
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_LISTING,
                label: 'toolbar.myStrains.myStrains',
                url: AppRoutes.STRAINS_LISTING,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_CREATE_NEW_STRAIN,
                label: 'toolbar.myStrains.createNewStrain',
                url: AppRoutes.STRAINS_CREATE_SELECTION,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_STRAIN_SHARING,
                label: 'toolbar.myStrains.strainSharing',
                url: AppRoutes.STRAIN_SHARE,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_SEQUENCING_REQUESTS,
                label: 'toolbar.myStrains.sequencingRequests',
                url: AppRoutes.STRAINS_SEQUENCING_REQUESTS,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_MY_PROBES,
                label: 'toolbar.myStrains.myProbes',
                url: AppRoutes.STRAINS_MY_PROBES,
                icon: '',
                internalRoute: true,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_FAQ,
                label: 'toolbar.myStrains.strainsFAQ',
                url: AppRoutes.STRAINS_FAQ,
                icon: '',
                internalRoute: true,
            }),
        ];
    }
}
